import { render, staticRenderFns } from "./supplier_list.vue?vue&type=template&id=0e8ee04a&scoped=true"
import script from "./supplier_list.vue?vue&type=script&lang=js"
export * from "./supplier_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ee04a",
  null
  
)

export default component.exports